// Semantic class names that describe the content type for styling

export const contentStyles = {
	// Text elements
	heading: {
		base: "content-heading",
		h1: "content-heading-1",
		h2: "content-heading-2",
		h3: "content-heading-3",
	},
	text: {
		paragraph: "content-paragraph",
		bold: "content-bold",
		italic: "content-italic",
		underline: "content-underline",
		strike: "content-strike",
	},
	link: "content-link",

	// Lists
	list: {
		ordered: "content-ordered-list",
		bullet: "content-bullet-list",
		item: "content-list-item",
	},

	// Special elements
	mention: "content-mention",
	horizontalRule: "content-hr",
	blockquote: "content-blockquote",
	code: {
		block: "content-code-block",
		inline: "content-code-inline",
	},

	// Media
	media: {
		wrapper: "content-media-wrapper",
		youtube: "content-youtube",
		vimeo: "content-vimeo",
		image: "content-image",
	},

	// Tables
	table: {
		wrapper: "content-table-wrapper",
		table: "content-table",
		row: "content-table-row",
		cell: "content-table-cell",
		header: "content-table-header",
	},

	// Layout & Alignment
	alignment: {
		left: "content-align-left",
		center: "content-align-center",
		right: "content-align-right",
		justify: "content-align-justify",
	},

	// Container classes
	container: {
		root: "content-root",
		editor: "content-editor",
		viewer: "content-viewer",
	},
} as const;
